import { RecentSearch } from './types';

export const LOCAL_STORAGE_KEY = 'searchHistory';
export const DISPLAY_LIMIT = 3;

export interface IRecentSearches {
    refresh: () => void;
    saveSearch: (keyword: string) => void;
}

export class RecentSearches implements IRecentSearches {
    results: RecentSearch[];
    displayLimit = DISPLAY_LIMIT;

    onRemoveClick(id: number) {
        this.removeFromLocalStorage(id);
        this.refresh();
    }

    onRemoveAllClick() {
        this.saveToLocalStorage('[]');
        this.refresh();
    }

    removeFromLocalStorage(id: number): void {
        const newResults = JSON.stringify(this.results.filter((item) => item.id !== id).map((item) => item.value));
        this.saveToLocalStorage(newResults);
    }

    createIndexedArray(storageData: string): RecentSearch[] {
        if (!storageData) return [];

        try {
            const parsedData: string[] = JSON.parse(storageData);

            return parsedData.filter((item) => item).map((item, index: number) => ({ id: index, value: item }));
        } catch (_) {
            return [];
        }
    }

    getFromLocalStorage(): string {
        const emptyStorage = '[]';

        if (typeof Storage === 'undefined') return emptyStorage;

        const searchHistory: string = localStorage?.getItem(LOCAL_STORAGE_KEY);

        if (!searchHistory) return emptyStorage;

        return searchHistory;
    }

    getResults(): RecentSearch[] {
        return this.createIndexedArray(this.getFromLocalStorage());
    }

    saveToLocalStorage(data: string): void {
        localStorage.setItem(LOCAL_STORAGE_KEY, data);
    }

    saveSearch(keyword: string) {
        let localStorageData: string[] = JSON.parse(this.getFromLocalStorage());

        if (!Array.isArray(localStorageData)) {
            localStorageData = [];
        }

        // Create the new array without allowing duplicates
        const newData = [keyword, ...localStorageData.filter((item) => item !== keyword)];

        this.saveToLocalStorage(JSON.stringify(newData));
    }

    refresh() {
        this.results = this.getResults();
    }

    getUrl(keyword: string): string {
        return '/s/' + encodeURIComponent(keyword) + '/';
    }
}
